// @flow
import styled, { css } from 'styled-components'
import { Button, Flex, Title } from 'src/theme/globalStyle'
import { media } from 'src/theme/style-utils'
import { Checkbox, StyledRadio } from 'src/components/Form'
import BorderSvg from 'src/assets/border.svg'
import type { Theme as ThemeType } from 'src/types'

export const RadioBox = styled.div`
  margin-top: 24px;
`
export const StyledA = styled.a`
  background-color: transparent;
  outline: none;
  text-decoration: none;
  font-family: 'RelativeBook', 'Helvetica', 'Arial', sans-serif;
  color: ${(props: { theme: ThemeType }) => props.theme.darkText};
  font-size: 16px;
  margin-left: 5px;
  border-image: url('${BorderSvg}') 143 round;
  border-top:0;
  border-left:0;
  border-right:0;
  border-bottom: 4px solid;
  cursor: pointer;
`
export const SecondInfoRibbon = styled.div`
  background-color: #c1e2bc;
  padding: 40px;
  position: relative;
  ${media.phone`
    width: calc(100% - 40px);
    bottom: -50px;
    left: -20px;
  `};

  ${media.tabletLarge`
    width: 100%;
    bottom: -50px;
    left: -40px;
  `};
`
export const InfoRibbon = styled.div`
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
  background-color: #a5c5c7;
  font-family: 'RelativeBook', 'Helvetica', 'Arial', sans-serif;
  color: #ffffff;
  font-size: 14px;
`
export const LoadingContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
`
export const StyledButton = styled.button`
  background-color: transparent;
  -webkit-appearance: none;
  padding-left: 0;
`
export const StyledOl = styled.ol``
export const StyledUl = styled.ul`
  counter-reset: line-number;

  li {
    margin-left: -25px;
    list-style: none;
    counter-increment: line-number;
    ::before {
      margin-left: -33px;
      content: '13.' counters(line-number, '.') '. ';
    }
  }
`
export const StyledLi = styled.li`
  font-family: 'RelativeBook', 'Helvetica', 'Arial', sans-serif;
  font-size: 13px;
  color: ${(props: { theme: ThemeType }) => props.theme.primaryText};
  text-align: left;
  margin: 0;
  padding-bottom: 5px;
  line-height: 1.5;

  ${props =>
    props.noPadding &&
    css`
      padding: 0;
    `};
`
export const OptionLabel = styled.div`
  background-color: #a5c5c7;
  font-family: 'RelativeBold', 'Helvetica', 'Arial', sans-serif;
  font-size: 16px;
  color: #000;
  text-align: center;
  padding: 15px 7px;

  ${media.desktop`
    font-weight: normal;
    color: #fff;
    padding: 7px;
  `}
`
export const OptionList = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;

  ${media.desktop`
    padding: 10px;
    flex-grow: 1;
    line-height: 1.3;
  `}
`
export const PlanButtonWrapper = styled.div`
  align-self: flex-end;
  width: 100%;
  flex-grow: 1;

  ${media.desktop`
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  `}
`
export const StyledPlanButton = styled(Button)`
  font-size: 14px;
  height: 50px;
  margin-bottom: 10px;
  pointer-events: none;

  display: flex;
  justify-content: center;
  align-items: center;
  ${media.desktop`
    height: 32px;
  `}
`
export const StyledCheckbox = styled(Checkbox)`
  display: inline-block;
`
export const SuperStyledRadioBox = styled(RadioBox)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  -webkit-font-smoothing: antialiased;
  ${media.desktop`
    flex-direction: row;
  `}
`
export const SuperStyledRadio = styled(StyledRadio)`
  transition: transform 100ms ease-in-out;
  ${props =>
    props.isSelected
      ? css`
          transform: scale(1.05);
          -webkit-box-shadow: 0 4.3px 21.4px 0 rgba(0, 0, 0, 0.15);
          -moz-box-shadow: 0 4.3px 21.4px 0 rgba(0, 0, 0, 0.15);
          box-shadow: 0 4.3px 21.4px 0 rgba(0, 0, 0, 0.15);

          button {
            background-color: #c1e2bc;
            color: black;
          }
        `
      : css`
          transform: scale(1);
        `};
  border: solid 1px #d2d9e2;
  border-radius: 5px;

  flex: 0 0 30%;
  padding-left: 0 !important;

  margin: 18px 10px;

  ${media.desktop`
    margin: initial;
  `};

  :hover {
    -webkit-box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.15);
    -moz-box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.15);
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.15);
  }
  ${media.desktop`
    flex-direction: row;
  `}
`
export const OptionHeading = styled.div`
  font-size: 18px;
  font-family: 'RelativeBold', 'Helvetica', 'Arial', sans-serif;
  text-align: center;
  padding: 15px 0;
`
export const StyledOption = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`
export const IconRow = styled.div`
  font-size: 12px;
  display: flex;
  flex-direction: row;
  padding-bottom: 20px;

  ${media.desktop`
    font-size: 12px;
  `}
`
export const Icon = styled.div`
  padding-right: 8px;

  width: 30px;
  flex-shrink: 0;

  ${media.desktop`
    width: 20px;
    padding-right: 3px;
  `}
`
export const IconLabel = styled.div``
export const IconLabelPriceBold = styled.span`
  font-family: 'RelativeBold', 'Helvetica', 'Arial', sans-serif;
`
export const IconLabelBold = styled.span`
  font-family: 'RelativeBold', 'Helvetica', 'Arial', sans-serif;

  ${media.desktop`
    display: block;
  `}
`
export const SelectButtonText = styled.span`
  margin-left: 3px;
`

export const NewFlex = styled(Flex)`
  ${media.phone`
  display:flex;
  margin-top: 5px;
  margin-bottom: 4px;
  `};
  ${media.tablet`
  margin-top: 50px;
  margin-bottom: 44px;
   `};
`
export const NewTitle = styled(Title)`
  ${media.phone`
    display:none;
  `};
  ${media.tablet`
    display:block;
  `}
`



// WEBPACK FOOTER //
// ./src/containers/SecureRoom/StyledElements.js